const loadingPage = require('@/assets/images/loading.gif');

const loading = {
  bind: (el: HTMLElement, binding: any, vnode: any) => {
    const elementNode: any = el;

    const node: any = document.createElement('div');
    node.classList.add('loading-page');

    node.style.backgroundImage = `url(${loadingPage})`;
    node.style.display = 'block';

    if (binding.value) {
      elementNode.appendChild(node);
    }
  },
  update: (el: HTMLElement, binding: any, vnode: any, oldVnode: any) => {
    const oldNode: any = oldVnode.elm;
    const elementNode: any = el;
    const loadingPageNode: any = elementNode.querySelectorAll('.loading-page');

    if (!binding.value) {
      loadingPageNode[0].style.display = 'none';
    }
  },
};

export default loading;
